import React, { useEffect, useRef, useState } from "react";
import { MoreHorizontal, Plus, Search } from "lucide-react";
import vendor_profile_icon from "../../../assets/profile_icon.svg";
import { BASE_URL } from "utils/constant";
import AddVendor from "./AddVendor";
import VendorDetails from "./VendorDetails";
import OrganizationEmptyState from "components/UI_components/OrganizationEmptyState";
import VendorEmptyIcon from "assets/empty state/VendorEmpty.svg";
import RequireAccess from "components/RequireAccess";
import Loader from "components/UI_components/Loader";
export default function Vendor({ currentMember }) {
  const [vendors, setVendors] = useState([]);

  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortField, setSortField] = useState("name");
  const [showSortMenu, setShowSortMenu] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const sortMenuRef = useRef(null);

  const [showAddVendor, setShowAddVendor] = useState(false);

  const [selectedVendor, setSelectedVendor] = useState(null);
  const organizationId = JSON.parse(localStorage.getItem("organization"))?.id;
  const fetchVendors = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("access");
      const org_id = JSON.parse(localStorage.getItem("organization"))?.id;

      const response = await fetch(
        `${BASE_URL}/inventory/list-org-vendors/${org_id}/`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const result = await response.json();

      if (response.ok && result.status && Array.isArray(result.data)) {
        setVendors(result.data);
      } else {
        console.error("Failed to load vendors", result.message);
      }
    } catch (error) {
      console.error("Error fetching vendors:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchVendors();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sortMenuRef.current && !sortMenuRef.current.contains(event.target)) {
        setShowSortMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const filteredVendors = [...vendors]
    .filter((vendor) =>
      vendor.name?.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      const getValue = (vendor) => {
        if (sortField === "advance") {
          return Number(vendor.advance_payment) || 0;
        }
        if (sortField === "paid") {
          return Number(vendor.paid_amount) || 0;
        }
        return vendor.name || "";
      };

      const valueA = getValue(a);
      const valueB = getValue(b);

      if (sortField === "name") {
        return sortOrder === "asc"
          ? String(valueA).localeCompare(String(valueB))
          : String(valueB).localeCompare(String(valueA));
      }

      const diff = Number(valueA) - Number(valueB);
      return sortOrder === "asc" ? diff : -diff;
    });

  const paginatedVendors = filteredVendors.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const totalPages = Math.ceil(filteredVendors.length / itemsPerPage);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };
  if (!organizationId) {
    return <OrganizationEmptyState />;
  }

  console.log("currentMember in Vendor:", currentMember);

  if (currentMember?.vendor_control === false && currentMember?.joined_as !== "owner" && currentMember?.is_admin === false) {
    return (
      <RequireAccess
        module="Vendor"
        currentMember={currentMember}
        permission="vendor_control"
      />
    );
  }

  return (
    <div className="w-[85%]">
      {selectedVendor ? (
        <VendorDetails
          vendor={selectedVendor}
          onClose={() => setSelectedVendor(null)}
        />
      ) : (
        <div
          className="w-full h-[90vh] p-4 pb-1 flex flex-col"
          style={{ overflowY: "auto" }}
        >
          {/* Top Bar */}
          <div
            className="flex items-center justify-between mb-4"
            style={{ height: "48px", gap: "20px" }}
          >
            <h2 className="text-[16px] ml-4 text-[#737373] whitespace-nowrap">
              {loading
                ? "Loading vendors..."
                : `${filteredVendors.length} Vendors`}
            </h2>

            <div className="flex items-center gap-[20px]">
              <div className="relative">
                <Search className="absolute left-2 top-2.5 h-4 w-4 text-[#877A90]" />
                <input
                  type="text"
                  placeholder="Search in vendor"
                  className="w-[259.51px] h-[34px] pl-8 pr-3 py-1.5 rounded-md border border-[#CCCCCC] bg-[#FFFFFF] text-[15px] text-[#877A90] placeholder-[#877A90] focus:outline-none focus:ring-2 focus:ring-[#3B0069]"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>

              <div className="relative" ref={sortMenuRef}>
                <button
                  onClick={() => setShowSortMenu((prev) => !prev)}
                  className="flex items-center justify-center gap-1 bg-[#ECE6F0] text-[#3B0069] text-sm font-medium rounded-md"
                  style={{ width: "120px", height: "32px", padding: "4px 12px" }}
                >
                  Sort ↓
                </button>
                {showSortMenu && (
                  <div
                    className="absolute right-0 mt-1 w-44 bg-white border border-gray-200 rounded-md shadow-lg z-10"
                    role="menu"
                    aria-label="Sort options"
                    style={{ minWidth: "260px" }}
                  >
                    <button
                      className={`w-full text-left px-3 py-1.5 text-sm hover:bg-gray-100 ${sortField === "name" && sortOrder === "asc"
                          ? "font-semibold text-[#3B0069]"
                          : ""
                        }`}
                      onClick={() => {
                        setSortField("name");
                        setSortOrder("asc");
                        setCurrentPage(1);
                        setShowSortMenu(false);
                      }}
                    >
                      Name (A → Z)
                    </button>
                    <button
                      className={`w-full text-left px-3 py-1.5 text-sm hover:bg-gray-100 ${sortField === "name" && sortOrder === "desc"
                          ? "font-semibold text-[#3B0069]"
                          : ""
                        }`}
                      onClick={() => {
                        setSortField("name");
                        setSortOrder("desc");
                        setCurrentPage(1);
                        setShowSortMenu(false);
                      }}
                    >
                      Name (Z → A)
                    </button>
                    <div className="my-1 border-t border-gray-200" />
                    <button
                      className={`w-full text-left px-3 py-1.5 text-sm hover:bg-gray-100 ${sortField === "advance" && sortOrder === "desc"
                          ? "font-semibold text-[#3B0069]"
                          : ""
                        }`}
                      onClick={() => {
                        setSortField("advance");
                        setSortOrder("desc");
                        setCurrentPage(1);
                        setShowSortMenu(false);
                      }}
                    >
                      Advance Amount (High → Low)
                    </button>
                    <button
                      className={`w-full text-left px-3 py-1.5 text-sm hover:bg-gray-100 ${sortField === "advance" && sortOrder === "asc"
                          ? "font-semibold text-[#3B0069]"
                          : ""
                        }`}
                      onClick={() => {
                        setSortField("advance");
                        setSortOrder("asc");
                        setCurrentPage(1);
                        setShowSortMenu(false);
                      }}
                    >
                      Advance Amount (Low → High)
                    </button>
                    <div className="my-1 border-t border-gray-200" />
                    <button
                      className={`w-full text-left px-3 py-1.5 text-sm hover:bg-gray-100 ${sortField === "paid" && sortOrder === "desc"
                          ? "font-semibold text-[#3B0069]"
                          : ""
                        }`}
                      onClick={() => {
                        setSortField("paid");
                        setSortOrder("desc");
                        setCurrentPage(1);
                        setShowSortMenu(false);
                      }}
                    >
                      Total Paid (High → Low)
                    </button>
                    <button
                      className={`w-full text-left px-3 py-1.5 text-sm hover:bg-gray-100 ${sortField === "paid" && sortOrder === "asc"
                          ? "font-semibold text-[#3B0069]"
                          : ""
                        }`}
                      onClick={() => {
                        setSortField("paid");
                        setSortOrder("asc");
                        setCurrentPage(1);
                        setShowSortMenu(false);
                      }}
                    >
                      Total Paid (Low → High)
                    </button>
                  </div>
                )}
              </div>

              <button
                onClick={() => setShowAddVendor(true)}
                className="flex items-center space-x-2 bg-[#3B0069] text-white text-sm font-medium rounded-[10px] px-4 py-1.5 hover:bg-[#2a004c] transition"
                style={{ height: "38px", width: "144px" }}
              >
                <div className="w-6 h-6 rounded-full bg-[#5E2D91] flex items-center justify-center">
                  <Plus className="w-4 h-4 text-white" />
                </div>
                <span>Vendor</span>
              </button>
            </div>
          </div>

          {/* Vendor Cards */}
          <div
            className="space-y-3 overflow-y-auto overflow-x-hidden pr-2 flex-1"
            style={{
              maxHeight: "530px",
              display: "flex",
              flexDirection: "column",
            }}
          >

            {loading ? (
              <Loader />
            ) : paginatedVendors.length > 0 ? (
              paginatedVendors.map((vendor, index) => (
                <div
                  key={vendor.id || index}
                  className="flex items-center mx-2 justify-between text-black cursor-pointer"
                  style={{
                    width: "100%",
                    maxWidth: "calc(100vw - 280px)",
                    // height: "82px",
                    paddingTop: "10px",
                    paddingRight: "40px",
                    paddingBottom: "10px",
                    paddingLeft: "40px",
                    gap: "195px",
                    borderRadius: "4px",
                    border: "1px solid #CCCCCC",
                    background: "#FFFFFF",
                    transition: "transform 0.2s",
                  }}
                  onClick={() => setSelectedVendor(vendor)}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "scale(1.01)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                  }}
                >
                  {/* Left: Icon + Info */}
                  <div className="flex items-center space-x-4">
                    <div className="w-10 h-10">
                      <img
                        src={vendor_profile_icon}
                        alt="Vendor Icon"
                        className="w-full h-full object-contain"
                      />
                    </div>

                    <div>
                      <p className="font-[16px] text-[#232323] cursor-pointer">
                        {vendor.name}
                      </p>
                      <p className="text-[14px] text-gray-500">
                        {vendor.vendor_type}
                      </p>
                    </div>
                  </div>

                  <div className="flex justify-end flex-1 gap-24">
                    <div className="text-left space-y-1 w-[120px]">
                      <p className="text-sm text-gray-500">Advance Amount</p>
                      <p className="font-[16px] text-[#232323]">
                        ₹ {vendor.advance_payment?.toLocaleString() || "0"}
                      </p>
                    </div>

                    <div className="text-left ml-[100px] space-y-1 w-[120px]">
                      <p className="text-sm text-gray-500">Total Paid</p>
                      <p className="font-[16px] text-[#232323]">
                        ₹ {vendor.paid_amount?.toLocaleString() || "0"}
                      </p>
                    </div>
                  </div>

                  {/* <MoreHorizontal className="text-[#232323] cursor-pointer" /> */}
                </div>
              ))
            ) : (
              <div className="flex flex-col items-center justify-center py-10">
                <img
                  src={VendorEmptyIcon}
                  alt="No Vendors"
                  className="mb-4"
                  width={240}
                />
                <span className="text-gray-500 text-2xl">No Vendors</span>
                <span className="text-gray-500 text-sm">
                  Add a vendor to purchase items now
                </span>
              </div>
            )}
          </div>

          {/* Pagination Controls */}
          <div className="flex justify-between items-center mt-4 px-4">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className={`h-8 w-24 flex items-center justify-center rounded-md ${currentPage === 1
                ? "bg-gray-300 cursor-not-allowed text-gray-500"
                : "bg-purple-500 text-white hover:bg-purple-600"
                }`}
            >
              Previous
            </button>

            <div className="flex items-center space-x-2">
              <label className="text-sm text-gray-500">Items per page:</label>
              <select
                value={itemsPerPage}
                onChange={(e) => {
                  setItemsPerPage(Number(e.target.value));
                  setCurrentPage(1);
                }}
                className="border border-gray-300 rounded-lg p-1"
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </select>
            </div>

            <span className="text-gray-700">
              Page {currentPage} of {totalPages}
            </span>

            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={
                currentPage === totalPages || filteredVendors.length === 0
              }
              className={`h-8 w-24 flex items-center justify-center rounded-md ${currentPage === totalPages || filteredVendors.length === 0
                ? "bg-gray-300 cursor-not-allowed text-gray-500"
                : "bg-purple-500 text-white hover:bg-purple-600"
                }`}
            >
              Next
            </button>
          </div>

          {showAddVendor && (
            <AddVendor
              onClose={() => {
                setShowAddVendor(false);
                fetchVendors();
              }}
            />
          )}
        </div>
      )}
    </div>
  );
}